import React, { useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import {
    LegendModule,
    TimeAxisModule,
    LineSeriesModule,
    ModuleRegistry,
    NumberAxisModule,
} from 'ag-charts-enterprise';
import { Modal, Button, Spin } from 'antd';
import { ExpandAltOutlined } from '@ant-design/icons';
import { EventsBySiteChartLogic } from './EventsBySiteChart';
import './EventsBySiteChart.scss';
import LoadingOrbitalSpinner from '../LoadingOrbitalSpinner/LoadingOrbitalSpinner';

ModuleRegistry.registerModules([
    TimeAxisModule,
    LegendModule,
    LineSeriesModule,
    NumberAxisModule,
]);

function EventsBySiteChart({ startAndEndUnixDatesParams, formatDateRange }) {
    const { chartConfig, loading } = EventsBySiteChartLogic(startAndEndUnixDatesParams, formatDateRange);
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <Spin spinning={loading} indicator={<LoadingOrbitalSpinner />}>
            <div className='events-by-site-chart'>
                <div className='events-by-site-chart-wrapper'>
                    <Button
                        className='events-by-site-chart-expand-btn'
                        type='text'
                        size='small'
                        icon={<ExpandAltOutlined />}
                        onClick={() => setModalOpen(true)}
                    />
                    {chartConfig && <AgCharts options={chartConfig} />}
                </div>
                <Modal
                    centered
                    open={modalOpen}
                    onCancel={() => setModalOpen(false)}
                    footer={null}
                    width='90%'
                >
                    {chartConfig && <AgCharts options={chartConfig} style={{ height: '70vh' }} />}
                </Modal>
            </div>
        </Spin>
    );
}

export default EventsBySiteChart;
